<section>
  <div class="d-flex flex-column">
    <label class="form-label mt-3 fs-6">Tipo de crédito</label>
    <div class="input-group mb-3">
      <select
        class="form-select px-2"
        [(ngModel)]="dataLocal.type_of_credit_id"
        (change)="updateDataValue(dataLocal.type_of_credit_id, 'type_of_credit_id')"
        [value]="dataLocal.type_of_credit_id"
        [id]="typeDebtKey"
      >
        <option [value]="1">
          Financiamento Veicular
        </option>
        <option [value]="2">
          Financiamento Imobiliário
        </option>
        <option [value]="3">Cartão de Crédito</option>
        <option [value]="4">Crédito Consignado</option>
        <option [value]="5">Familiar / Amigo</option>
        <option [value]="6">Outros</option>
        <label class="input-group-text" [for]="typeDebtKey">Options</label>
      </select>
    </div>
  </div>

  <div class="row mt-2 mb-4">
    <div class="col-md-4">
      <label class="form-label mt-2 fs-6">Valor do contrato</label>
      <app-prefixed-input
        [elementID]="contractValueKey"
        [pref]="'R$'"
        (parentValue)="updateDataValue($event, 'contract_value')"
        [callback]="dataLocal.contract_value"
      ></app-prefixed-input>
    </div>

    <div class="col-md-4">
      <label class="form-label mt-2 fs-6">Valor da parcela</label>
      <app-prefixed-input
        [elementID]="installmentValueKey"
        [pref]="'R$'"
        (parentValue)="updateDataValue($event, 'installment_value')"
        [callback]="dataLocal.installment_value"
      ></app-prefixed-input>
    </div>

    <div class="col-md-4">
      <label class="form-label mt-2 fs-6">Taxa de Juros</label>
      <div class="input-group mt-2">
        <label class="input-group-text px-3" for="inputGroupSelect01">%</label>
        <input
          [id]="interestRateKey"
          type="number"
          class="form-control p-1 w-25"
          [(ngModel)]="dataLocal.interest_rate"
          (change)="updateDataValue(dataLocal.interest_rate, 'interest_rate')"
        />
        <select
          class="form-select px-2"
          [(ngModel)]="dataLocal.interest_rate_period"
          (change)="
            updateDataValue(dataLocal.interest_rate_period, 'interest_rate_period')
          "
          [value]="dataLocal.interest_rate_period"
          [id]="interestRateChooseKey"
        >
          <option [value]="'mes'" selected>Ao mês</option>
          <option [value]="'ano'">Ao ano</option>
        </select>
      </div>
    </div>
  </div>

  <!-- <div class="">
    <label class="form-label mt-2  fs-6">Taxa de juros</label>
    <app-prefixed-input
      [elementID]="interestRatePerMonthKey"
      [pref]="'%'"
      (parentValue)="updateDataValue($event, 'interestRatePerMonth')"
      [callback]="data.interestRatePerMonth"
    ></app-prefixed-input>
  </div> -->
</section>
